import { useParams } from 'react-router'
import { trpc } from '../../core/trpc'
import Crumb from './Crumb'

const SubsidiaryByLeadBreadCrumb = () => {
  const { pipelineId, leadId } = useParams()

  if (!leadId) throw new Error('missing required prop leadId')

  const { data } = trpc.subsidiary.getSubsidiaryByLeadId.useQuery({ id: leadId! })

  return (
    <Crumb text={data?.name} path={`/subsidiary/${data?.id}/pipeline/${pipelineId}/leads/view/default?stage_id=&sortBy%5Bdays_in_stage%5D=desc`} />
  )
}

export default SubsidiaryByLeadBreadCrumb
